import { createApp } from 'vue/dist/vue.esm-bundler'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import errorParser from '@/utils/error-parser';
import getEnv from '@/utils/env';
import snotify from 'vue3-snotify';
import 'vue3-snotify/style';
import BootstrapVueNext from 'bootstrap-vue-next';
import CoreuiVue from '@coreui/vue';
import CIcon from '@coreui/icons-vue'
import {iconSet}  from '@/assets/icons';
import VueDiff from 'vue-diff';
import 'vue-diff/dist/index.css';
import mitt from 'mitt';
import AuthWrapper from "@/components/AuthWrapper";
import VueFullscreen from 'vue-fullscreen'
import Vue3ColorPicker from "vue3-colorpicker";
import DateFormatService from '@/services/DateFormatService';
import EnvironmentService from '@/services/EnvironmentService';
import "vue3-colorpicker/style.css";
const emitter = mitt();
axios.defaults.baseURL = `${getEnv('VUE_APP_QSC_ADMIN_UI_URL')}/api/v1/`;
axios.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token
    }

    // Allow search requests to target a dedicated endpoint (e.g. a search
    // service on a different port) while everything else keeps using the
    // application url. Falls back to the application url when not configured.
    const appBase = EnvironmentService.getUrl();
    const searchBase = EnvironmentService.getSearchUrl();
    if (searchBase && searchBase !== appBase) {
        const url = config.url;
        const isAbsolute = url != null && /^https?:\/\//i.test(url);
        // Match relative search paths like "/search/<tenant>/<code>".
        if (url != null && !isAbsolute && /^\/?search\/[^/]+\/[^/]+/.test(url)) {
            config.baseURL = `${searchBase}/api/${EnvironmentService.getVersion()}/`;
        }
    }

    return config;
}, function (error) {
    return Promise.reject(errorParser.parse(error));
});

const app   = createApp(App)
    .use(store)
    .use(snotify,{toast: {
            position: "rightBottom",
            showProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
        }})
    .use(CoreuiVue)
    .use(router)
    .use(VueFullscreen)
    .use(Vue3ColorPicker)
    .use(BootstrapVueNext)
    .use(VueDiff)
    .provide('icons', iconSet)
    .provide('snotify',snotify)
    .component('CIcon', CIcon)
    .component("AuthWrapper",AuthWrapper)

  //  .mount("#app")

app.config.globalProperties.emitter = emitter;
router.isReady().then(() => {
    DateFormatService.init();
    app.mount('#app');
})

export const appInstance = app;
